const ERROR_TYPES = {
  1: 'mWeb_A&V_Minimum_Requirement_Warning_Flash',
  2: 'mWeb_A&V_Maximum_Requirement_Warning_Flash',
};

const ONBOARDING_SCREEN_BTN_TYPES = {
  1: 'mWeb_A&mWeb_OBScreen_Add_to_Cart_Clicked',
  2: 'mWeb_A&mWeb_OBScreen_Login_Clicked',
  3: 'mWeb_A&mWeb_OBScreen_Place_Order_Clicked',
  4: 'mWeb_A&mWeb_OBScreen_Start_Ordering_Clicked',
};

export const ONBOARDING_SCREEN_BTN_ENUMS = {
  ADD_TO_CART: 1,
  LOGIN: 2,
  PLACE_ORDER: 3,
  START_ORDERING: 4,
};

export const menuTrack = (Restaurant_id, Order_Time, User_ID, Order_Type_ID) => {
  try {
    window.__bgtracker.track('VIEW_RESTAURANT_MENU', {
      hitName: 'VIEW_RESTAURANT_MENU',
      Restaurant_id,
      Order_Time,
      User_ID,
      USER_SIGNED_IN: !!User_ID,
      Order_Type_ID,
    });
  } catch (error) {
    console.log(error);
  }
};

export const menuNavigationTrack = (event, section, id, phone) => {
  window.__bgtracker.track(event, {
    hitName: event,
    Section_Clicked: section,
    Section_Clicked_ID: id,
    User_ID: phone,
    USER_SIGNED_IN: !!phone,
  });
};

export const itemSearchTrack = (
  Item_Searched,
  ITEM_SEARCHES,
  User_ID,
  Recent_search_clicked,
  Trending_search_clicked
) => {
  if (!Item_Searched) return;
  window.__bgtracker.track('ITEM_SEARCHED', {
    hitName: 'ITEM_SEARCHED',
    Item_Searched,
    ITEM_SEARCHES,
    User_ID,
    USER_SIGNED_IN: !!User_ID,
    Recent_search_clicked,
    Trending_search_clicked,
  });
};

export const addBtnTrack = (data) => {
  if (!data) return;
  try {
    window.__bgtracker.track('mWeb_A&V_Add_Item_Clicked', {
      hitName: 'mWeb_A&V_Add_Item_Clicked',
      ...data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const addToCartTrack = (data) => {
  if (!data) return;
  try {
    window.__bgtracker.track('mWeb_A&V_Add_to_Cart_Clicked', {
      hitName: 'mWeb_A&V_Add_to_Cart_Clicked',
      ...data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const addToCartToasts = (errorType, data) => {
  const hitName = ERROR_TYPES[errorType];
  if (!data) return;
  try {
    window.__bgtracker.track(hitName, {
      hitName,
      ...data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const startOrderingTrack = (btnType, data) => {
  const hitName = ONBOARDING_SCREEN_BTN_TYPES[btnType];
  if (!data) return;
  try {
    window.__bgtracker.track(hitName, {
      hitName,
      ...data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const viewOrderTrack = (data) => {
  const hitName = 'mWeb_Menu_Active_Orders_View_Button_Clicked';
  if (!data) return;
  try {
    window.__bgtracker.track(hitName, {
      hitName,
      ...data,
    });
  } catch (error) {
    console.log(error);
  }
};
